import React from 'react';
import {connect} from 'react-redux'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
import * as colors from 'material-ui/styles/colors';
import ThemeDefault from '../../theme-default';
import Snackbar from 'material-ui/Snackbar';

import Loading from '../../components/Loading'
import LoginForm from './LoginForm'
import * as actions from '../../actions'

import {Redirect} from 'react-router-dom'

const styles = {
  loginContainer: {
    minWidth: 320,
    maxWidth: 400,
    // height: 'auto',
    // position: 'absolute',
    // top: '20%',
    // left: 0,
    // right: 0,
    // margin: 'auto',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'

  },
  paper: {
    padding: 20,
    overflow: 'auto'
  },
  flatButton: {
    color: colors.grey500
  },
  btn: {
    background: '#4f81e9',
    color: colors.white,
    padding: 7,
    borderRadius: 2,
    margin: 2,
    fontSize: 13
  },
  btnSpan: {
    marginLeft: 5
  },
};


class LoginPage extends React.Component {

  componentDidUpdate() {
  }

  render() {

    const {
      auth,
      handleLogin,
      load,
      snackbar,
      handleSnackbarClose
    } = this.props

    return this.props.auth.loginState != 1 ?

      (<MuiThemeProvider muiTheme={ThemeDefault}>
        <div style={{backgroundColor: colors.grey100}}>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>

            <Paper style={{padding: 20, overflow: 'auto'}} zDepth={3}>

              <LoginForm onLogin={handleLogin} />
              <Loading open={load}/>

            </Paper>

          </div>
          <Snackbar
            open={snackbar.open}
            message={snackbar.message}
            autoHideDuration={4000}
            onRequestClose={handleSnackbarClose}
            bodyStyle={{backgroundColor: snackbar.color}}
          />
        </div>
      </MuiThemeProvider>) :
      <Redirect to={'/'} />
  }
};

const mapStateToProps = (state) => ({
  load: state.global.load,
  auth: state.auth,
  snackbar: state.global.snackbar,
})

const mapStateToDispatch = (dispatch) => ({
  handleLogin: (form) => {dispatch(actions.userLogin(form))},
  handleSnackbarClose: () => {dispatch(actions.reducerSnackBar(false, ''))},
})

LoginPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(LoginPage)

export default LoginPage;



// WEBPACK FOOTER //
// ./src/containers/auth/LoginPage.js